import { NotifyHelper } from 'classes/helpers/notify.helper';
import { Controller } from 'lib_ts/enums/routing/controllers';
import { UserModelsRoutes } from 'lib_ts/enums/routing/routes/user-models';
import { IServerResponse } from 'lib_ts/interfaces/common/i-server-response';
import { IMachineModel } from 'lib_ts/interfaces/modelling/i-machine-model';
import { BaseRESTService } from 'services/_base-rest.service';

export class UserMachineModelsService extends BaseRESTService {
  private static instance: UserMachineModelsService;
  static getInstance(): UserMachineModelsService {
    if (!UserMachineModelsService.instance) {
      UserMachineModelsService.instance = new UserMachineModelsService();
    }

    return UserMachineModelsService.instance;
  }

  private constructor() {
    super({
      controller: Controller.UserModels,
    });
  }

  async getModel(id: string): Promise<IMachineModel | undefined> {
    return await this.get({
      uri: `${UserModelsRoutes.GetModel}/${id}`,
    })
      .then((result: IServerResponse) => {
        if (!result.success) {
          NotifyHelper.warning({
            message_md:
              result.error ?? 'There was an error while fetching the model.',
          });
          return undefined;
        }

        return result.data as IMachineModel;
      })
      .catch((reason) => {
        console.error(reason);
        NotifyHelper.error({
          message_md: 'There was an error while fetching the model.',
        });
        return undefined;
      });
  }

  // mainly for users or admins to be able to mark a model as published upon finishing BTC
  async publishModel(id: string): Promise<IMachineModel | undefined> {
    return await this.get({
      uri: `${UserModelsRoutes.PublishModel}/${id}`,
    })
      .then((result: IServerResponse) => {
        if (!result.success) {
          NotifyHelper.warning({
            message_md:
              result.error ?? 'There was an error while publishing the model.',
          });
          return undefined;
        }

        return result.data as IMachineModel;
      })
      .catch((reason) => {
        console.error(reason);
        NotifyHelper.error({
          message_md: 'There was an error while publishing the model.',
        });
        return undefined;
      });
  }
}
